<template>
    <div class="openpoints">
		<b-modal
			no-close-on-backdrop
			:title="formApproveRO ? 'Customer Approval Info' : 'Do you want to mark this issue as approved ?'"
			class="modal-success"
			v-model="approveIssueDlg"
			ok-variant="success"
			:ok-only="formApproveRO ? true : false"
			:ok-title="formApproveRO ? 'Close' : 'Approve'"
			size="lg"
            @ok="onApproveIssue"
		>
            <b-container fluid>
                <b-form @submit.prevent="onApproveIssue" @reset="onResetIssue">
                    <b-row>
                        <b-col>
                            <b-form-group id="input-group-1" label="Agreed with" label-for="input-agreed" >
                                <b-form-select id="input-agreed" v-model="formApprove.agreedwith" :options="peoples" />
                            </b-form-group>
                            <b-form-group id="input-group-1" label="Comment" label-for="input-agreed" >
                                <b-form-textarea
                                            id="input-description"
                                            v-model="formApprove.description"
                                            rows="7"
                                            placeholder=""
                                            required
                                ></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
		<b-modal
			no-close-on-backdrop
			:title="formDoneRO ? 'Marsilli Done info' : 'Do you want to mark this issue as done ?'"
			class="modal-success"
			v-model="doneIssueDlg"
			ok-variant="success"
			:ok-only="formDoneRO ? true : false"
			:ok-title="formDoneRO ? 'Close' : 'Mark Done'"
			size="lg"
            @ok="onDoneIssue"
		>
            <b-container fluid>
                <b-form @submit.prevent="onDoneIssue" @reset="onResetIssue">
                    <b-row>
                        <b-col>
                            <b-form-group id="input-group-1" label="Agreed with" label-for="input-agreed" >
                                <b-form-select id="input-agreed" v-model="formDone.agreedwith" :options="peoples" />
                            </b-form-group>
                            <b-form-group id="input-group-1" label="Comment" label-for="input-agreed" >
                                <b-form-textarea
                                            id="input-description"
                                            v-model="formDone.description"
                                            rows="7"
                                            placeholder=""
                                            required
                                        ></b-form-textarea>
                                </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
		<b-modal
			no-close-on-backdrop
			:title="cloningIssue ? 'Clone Issue' : 'Add Issue'"
			class="modal-success"
			v-model="addIssueDlg"
			ok-variant="success"
			:ok-only="false"
			ok-title="Save"
			size="lg"
            @ok="onSubmitIssue"
		>
			<b-container fluid>
                <b-form @submit.prevent="onSubmitIssue" @reset="onResetIssue">
                    <b-row>
                        <b-col cols="3">
                            <b-form-group id="input-group-1" label="Date" label-for="input-date" >
                                <b-form-input id="input-date" v-model="formIssue.ts" type="date" placeholder="Insert issue date" required />   
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-form-group id="input-group-2" label="Issue title" label-for="input-issue" >
                                <b-form-input id="input-issue" v-model="formIssue.issue" type="text" placeholder="Insert the description of the action" required />   
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <b-form-group id="input-group-1" label="Due Date" label-for="input-due-date" >
                                <b-form-input id="input-due-date" v-model="formIssue.duets" type="date" placeholder="Insert due date" required />   
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Line" label-for="input-line" >
                                        <b-form-input id="input-line" v-model="formIssue.line" type="text" placeholder="Insert the line" required />   
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="SW Unit" label-for="input-swunit" >
                                        <b-form-input id="input-swunit" v-model="formIssue.swunit" type="text" placeholder="Insert the SW unit" required />   
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <b-form-group id="input-group-1" label="Status" label-for="input-status" >
                                <b-form-select id="input-status" v-model="formIssue.statusid" :options="states" required></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Owner" label-for="input-owner" >
                                        <b-form-select id="input-owner" v-model="formIssue.owner" :options="owners" required></b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Category" label-for="input-category" >
                                        <b-form-select id="input-category" v-model="formIssue.catid" :options="categories" required></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <b-form-group id="input-group-1" label="Priority" label-for="input-priority" >
                                <b-form-select id="input-priority" v-model="formIssue.prioritylevel" :options="priorities" required></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Phase" label-for="input-phase" >
                                        <b-form-select id="input-phase" v-model="formIssue.phaseid" :options="phases" required></b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Responsible" label-for="input-responsible" >
                                        <b-form-select id="input-responsible" v-model="formIssue.respid" :options="responsibles" required></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                </b-form>
			</b-container>
		</b-modal>
        <b-card>
            <b-button v-if="!noAdd" @click="cloneIssue()" type="submit" variant="primary" v-show="clonable"> CLONE ISSUE </b-button>
            &nbsp;&nbsp;&nbsp;
            <b-button v-if="!noAdd" @click="addIssue()" type="submit" variant="primary" > NEW ISSUE </b-button>
            <AgGridVue :style="`width: calc(100% - 0px); height: ${height}`" 
                class="ag-theme-alpine" 
                :columnDefs="columnDefs" 
                :rowData="issues"
                :defaultColDef="defaultColDef" 
                :suppressColumnVirtualisation="false" 
                :getRowClass="getRowClass"
                @first-data-rendered="onFirstDataRendered" 
                @grid-ready="onGridReady"
                @row-double-clicked="onRowDoubleClicked"
                @row-clicked="onRowClicked">
            </AgGridVue>
        </b-card>
    </div>
</template>
<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);

export default {
    name: "OpenPoints",
    components: {
        AgGridVue,
    },
    data: function () {
        return {
            formApprove: {
                agreedwith: "",
                description: "",
                issueid: null,
            },
            formDone: {
                agreedwith: "",
                description: "",
                issueid: null,
            },
            formApproveRO: false,
            formDoneRO: false,
            formIssue: {
                no: 0,
                ts: null,
                duets: null,
                line: "",
                swunit: "",
                issue: "",
                owner: "",
                catid: null,
                respid: null,
                phaseid: null,
                statusid: null,
                prioritylevel: 1,
            },
            peoples: [],
            owners: [{ value: "Marsilli", text: "Marsilli" }, { value: "Customer", text: "Customer" }],
            priorities: [],
            phases: [],
            categories: [],
            states: [],
            responsibles: [],
            addIssueDlg: false,
            approveIssueDlg: false,
            cloningIssue: false,
            dblClickWaitTimeout: false, // viene settato al click per aspettare il doppioclick
            doneIssueDlg: false,
            gridApi: null,
            columnApi: null,
            defaultColDef: {
                sortable: true,
                filter: true,
				resizable: true, 
            },
            columnDefs: [
                { hide: true, field: "id" },
                { hide: !this.noAdd, headerName: "Unit", width:"100px",field: "unit", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "No.", width:"80px",field: "no", filter: 'agNumberColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Date", width:"110px",field: "ts", filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Issue", field: "issue", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Status", width:"100px",field: "status", cellClass: 'ag-left-aligned-cell', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, cellRenderer: params => { return `<div style="width: 20px;height: 20px;background-color: ${params.value};border-radius: 50%;margin:10px;border: 2px solid black;"></div>`}},
                { headerName: "Owner", width:"110px",field: "owner", cellClass: 'ag-left-aligned-cell', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, sort: { direction: 'desc', priority: 0 }, },
                { headerName: "Priority", width:"150px",cellClass: 'ag-left-aligned-cell', field: "priority", filter: 'agNumberColumnFilter',valueFormatter: this.priorityFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Category", width:"110px",field: "category", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "SW Unit", width:"110px",field: "swunit", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Phase", width:"110px",field: "phase", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Line", width:"110px",field: "line", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] },cellClass: 'ag-left-aligned-cell',  },
                { headerName: "Responsible", width:"110px",field: "responsible", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Due Date", width:"110px",field: "duets", filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Done", width:"110px",field: "donets", onCellClicked: this.onDoneCellClicked, cellClass: params => {return params.value || !this.machine ? 'check' : "pointer check"}, cellRenderer: params => { return params.value ? this.dateFormatter(params) : `&#9633; set`}, },
                { headerName: "Approved", width:"110px",field: "approvedts", onCellClicked: this.onApprovedCellClicked, cellClass: params => {return params.value || !this.machine ? 'check' : "pointer check"}, cellRenderer: params => { return params.value ? this.dateFormatter(params) : `&#9633; set`}, },
                // { headerName: "Subject", maxWidth: '200', editable: true, cellClass: 'ag-left-aligned-cell', field: "subject", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                // { headerName: "Description", maxWidth: 350, editable: true, cellClass: 'ag-left-aligned-cell', field: "descr", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Edit", hide: !this.$store.getters.marsilli, width:"110px",field: "approvedts", onCellClicked: this.onEditCellClicked, cellClass: () => {return "pointer"}, cellRenderer: params => { if(params.data.donets || params.data.approvedts) return ""; else return `&#x1F4DD;`}, },
                { headerName: "Delete", hide: !this.$store.getters.marsilli, width:"110px",field: "approvedts", onCellClicked: this.onDeleteCellClicked, cellClass: () => {return "pointer"}, cellRenderer: params => { if(params.data.donets || params.data.approvedts) return ""; else return `&#x1F5D1;&#xFE0F;`}, },
            ],
            issues: [],
            currIssueId: 0,
            editId: 0,
            clonable: false
        }
    },
    watch: {
        filtro: {
            handler: async function (val) {
                console.log("filter changed",val)
                this.refreshIssues()
            },
            immediate: true
        }
    },
    props: {
        noAdd: { type: Boolean, default: false },
        height: { type: String, default: "calc(100vh - 750px)" },
        filtro: { type: Array, default: null }
    },
    computed: {
        machine(){
            return this.$store.getters.machine
        },
        section(){
            return this.$store.getters.section
        },
        marsilli() {
            return this.$store.getters.marsilli
        },
    },
    async mounted(){
        let unitNames = await API.getUnitNames();
		let data = await API.getUnits();
		let schede = data.map((d) => ({
			client: d.client_code,
			nome: d.name,
			codice: d.code,
			location: d.location,
			img: d.img,
			macchina: d.macchina,
			descr: d.descr,
			delivered: d.delivered,
			label_info: d.label_info,
			upd: 0,
			nomepers: (unitNames.find(u => u.code==d.code) || {}).name || d.name,
			locationpers: (unitNames.find(u => u.code==d.code) || {}).location || d.location
		})); // upd serve per l'aggiornamento delle immagini
        console.log("schede",schede)
        console.log("machine",this.machine)

        await this.refreshIssues()

        this.priorities = (await API.getPriorities()).map((p) => ({value:p.level, text:p.description}));
        console.log("priorities",this.priorities)
        this.phases = (await API.getPhases(this.section)).map((p) => ({value:p.id, text:p.descr}));
        this.categories = (await API.getCategories()).map((p) => ({value:p.id, text:p.descr}));
        this.states = (await API.getStates()).map((p) => ({value:p.id, text:p.descr}));
        this.responsibles = (await API.getResponsibles()).map((p) => ({value:p.id, text:p.descr}));

        if(this.machine)
            this.peoples = (await API.getTeams(this.machine.codice, this.section)).map(p => ({text: `${p.name} ${p.surname} - ${p.email}`, value: p.id}));

        console.log("peoples", this.peoples)
        if(this.gridApi)
            this.gridApi.redrawRows() // le priorities sono state disegnate prima di avere i valori !
    },
    methods: {
        async refreshIssues(){
            this.issues = await API.prinIssues(this.machine ? this.machine.codice : null, this.section, this.filtro)
            this.issues = this.issues.map((i,idx) => ({...i, no: idx+1, ts: new Date(i.ts), duets: new Date(i.duets), approvedts: i.approvedts ? new Date(i.approvedts):  null, donets: i.donets ? new Date(i.donets) : null}))
            console.log("issues",this.issues)
        },
        addIssue(){
            console.log("addIssue")
            this.editId = 0
            this.formIssue = { no: 0, ts: null, duets: null, line: "", swunit: "", issue: "", owner: "", catid: null, respid: null, phaseid: null, statusid: null, prioritylevel: 1, },
            this.addIssueDlg = true
        },
        cloneIssue(){
            console.log("cloneIssue")
            let issue = this.issues.find(i => i.id == this.currIssueId)
            console.log("Issue", issue)
            this.formIssue = { no: 0, ts: this.toYYYYMMDD(new Date(issue.ts)), duets: this.toYYYYMMDD(new Date(issue.duets)), line: issue.line, swunit: issue.swunit, issue: issue.issue + " cloned", owner: issue.owner, catid: issue.catid, respid: issue.respid, phaseid: issue.phaseid, statusid: issue.statusid, prioritylevel: issue.priority },
            this.addIssueDlg = true
        },
        toYYYYMMDD(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // mesi da 0 a 11
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        async onSubmitIssue(){
            this.formIssue.unit = this.machine.codice
            console.log("onSubmitIssue",this.formIssue)
            if(this.editId){
                this.formIssue.issueid = this.editId
            }
            let newIssueId = await API.addIssue(this.formIssue,this.section)
            console.log("newIssueId", newIssueId)
            console.log("cloningIssue",this.cloningIssue,this.currIssueId)
            await API.cloneIssueActionsAndAttachments(newIssueId, this.currIssueId,this.section)
            // this.gridApi.redrawRows()
            await this.refreshIssues()
            this.addIssueDlg = false
            this.$store.commit("incPStates",null);
        },
        async onApproveIssue(){
            if(this.formApproveRO) return
            console.log("onApproveIssue",this.formApprove)
            this.approveIssueDlg = false
            await API.pi_approve(this.formApprove.agreedwith, this.formApprove.description, this.formApprove.issueid, this.section)
            await this.refreshIssues()
            this.formApprove = {agreedwith: "",description: "",issueid: null}
        },
        async onDoneIssue(){
            if(this.formDoneRO) return
            console.log("onDoneIssue",this.formDone)
            this.doneIssueDlg = false
            await API.pi_done(this.formDone.agreedwith, this.formDone.description, this.formDone.issueid, this.section)
            await this.refreshIssues()
            this.formDone = {agreedwith: "",description: "",issueid: null}
        },
        onResetIssue(){
            console.log("onResetIssue")
            this.addIssueDlg = false
        },
        dateFormatter(params) {
            return params.value.toLocaleDateString();
        },
        priorityFormatter(params) {
            try {
                return params.value + " - " + this.priorities.find(p => p.value == params.value).text
            } catch (error) {
                return " ... "                
            }
        },
		async onRowDoubleClicked(params){
            clearTimeout(this.dblClickWaitTimeout) // se arriva il doppio click annullo il timeout del singolo click
            this.dblClickWaitTimeout = false
			console.log("rowDoubleClicked",params.data)
            this.$store.commit("issue", params.data);
            this.$router.push("/practions");
        },
		async onRowClicked(params){
            this.dblClickWaitTimeout = setTimeout(async () => {
                if(this.currIssueId == params.data.id) {
                    this.currIssueId = 0
                } else {
                    this.currIssueId = params.data.id
                    this.clonable = !!params.data.donets || !!params.data.approvedts
                    console.log("clonable",this.clonable)
                }
                console.log("rowClicked",params.data)
                this.$store.commit("issue", params.data);
                await this.refreshIssues()
            }, 400) 
        },
        async onApprovedCellClicked(params){
            console.log("onApprovedCellClicked",params)
            if(params.data.approvedts) {
                this.formApproveRO = true
                let data = await API.getIssueApproveData(params.data.id, this.section)
                this.formApprove.agreedwith = data.agreed_with
                this.formApprove.description = data.notes    
                this.approveIssueDlg = true
                return
            }
            if(!this.machine) return
            this.formApproveRO = false
            this.approveIssueDlg = !this.marsilli
            this.formApprove = {
                agreedwith: "",
                description: "",
                issueid: params.data.id,
            }
        },
        async onDoneCellClicked(params){
            console.log("onDoneCellClicked",params)
            if(params.data.donets) {
                this.formDoneRO = true
                let data = await API.getIssueDoneData(params.data.id, this.section)
                this.formDone.agreedwith = data.agreed_with
                this.formDone.description = data.notes    
                this.doneIssueDlg = true
                return
            }
            if(!this.machine) return
            this.doneIssueDlg = this.marsilli
            this.formDone = {
                agreedwith: "",
                description: "",
                issueid: params.data.id,
            }
        },
        onGridReady(params) {
			console.log("Grid Ready")
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
			// this.columnApi.applyColumnState({
			// 	state: [{ colId: 'datefrom', sort: 'desc' }],
			// 	defaultState: { sort: null },
			// });
        },
        async onEditCellClicked(params){
            console.log("onEditCellClicked",params)
            if(params.data.donets || params.data.approvedts) return
            let issue = this.issues.find(i => i.id == this.currIssueId)
            this.editId = issue.id
            console.log("Issue", issue)
            this.formIssue = { no: 0, ts: this.toYYYYMMDD(new Date(issue.ts)), duets: this.toYYYYMMDD(new Date(issue.duets)), line: issue.line, swunit: issue.swunit, issue: issue.issue, owner: issue.owner, catid: issue.catid, respid: issue.respid, phaseid: issue.phaseid, statusid: issue.statusid, prioritylevel: issue.priority },
            this.addIssueDlg = true
        },
        async onDeleteCellClicked(params){
            console.log("onDeleteCellClicked",params)
            if(params.data.donets || params.data.approvedts) return
            // chiedo conferma
            this.$bvModal.msgBoxConfirm("Are you sure you want to delete this action ?", {
                title: "Confirm Deletion",
                okTitle: "OK, Delete",
                cancelTitle: "Cancel",
                footerClass: "p-2",
                hideHeader: true,
                centered: true
            }).then(async (value) => {
                if (value) {
                    // l'utente ha confermato l'eliminazione
                    await API.deleteAction(params.data.id, this.section)
                    this.refreshActions()
                }
            });
            this.formDelete = { actionid: params.data.id }
            this.deleteActionDlg = true
        },
		// eslint-disable-next-line no-unused-vars
        onFirstDataRendered(event) {
            if(this.currTab==0) {
                this.columnApi.autoSizeAllColumns();
				console.log("autoSizeAllColumns1")
			}
        },
        getRowClass(params) {
            // Se vuoi assegnare una classe CSS alla riga della "Toyota"
            // return params.data.make === "Toyota" ? 'highlight-row' : '';
            let classe = (params.data.id == this.currIssueId) ? "rowsel" : ""
            // console.log("getRowClass",params.data.id,classe)
            return classe
        }

    }
}

</script>
<style scoped>
div.openpoints button {
	background-color: #9a240d !important;
	border-color: #9a240d !important;
	margin-bottom: 10px;
}
div.openpoints button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.openpoints button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
</style>
<style>
.rowsel {
    background-color: lightcoral !important;
}
div.openpoints .pointer {
    cursor: pointer;
}
div.openpoints .check span div {
    font-size: x-large;
    display: flex;
    align-items: center;
}
</style>
